<template>
    <el-form-item :required="required" :label="label" :prop="prop">
        <el-input :maxlength="maxlength"  :show-word-limit="showWordLimit" :placeholder="placeholder" :style="style" v-model="data"></el-input>
    </el-form-item>
</template>

<script>
  export default {
    name: "FormItemInput",
    props:{
      prop:{
        type:String
      },
      value: {
        type: [String, Number, Array],
      },

      label:{
        type:String,
        default:''
      },
      required:{
        type:Boolean,
        default:false
      },
      showWordLimit:{
        type:Boolean,
        default:false
      }, maxlength:{
        type:String,
        default:'20'
      },
      width:{
        type:String,
        default: '100%'
      },placeholder:{
        type:String,
        default: ''
      }
    },
    model:{
      prop:'value',
      event:'change'
    },
    computed: {
      //双向数据绑定语法糖
      data: {
        get() {
          return this.value
        },
        set(val) {
          // console.log('set')
          // console.log(val)
          this.$emit('change', val)
        }
      },
      style:{
        get() {
          return {
            width:this.width
          }
        },
      }
    },
    data(){
      return{

      }
    }
  }
</script>

<style scoped>

</style>
